import contentfulGql from 'js/lib/contentfulGql';

export const degreeHomePageContentQuery = contentfulGql`#graphql
query DegreeHomePageContent($preview: Boolean!, $slug: String!, $locale: String!) {
  universityProgramPageContentCollection(preview: $preview, locale: $locale, where: { slug: $slug }) {
    items {
      ...DegreeHomePageContent_UniversityProgramPageContent
    }
  }
  premiumCertificatePageContentCollection(preview: $preview, locale: $locale, where: { slug: $slug }) {
    items {
      ...DegreeHomePageContent_PremiumCertificatePageContent
    }
  }
}

fragment DegreeHomePageContent_UniversityProgramPageContent on UniversityProgramPageContent {
  programName
  partnerInformation {
    ...DegreeHomePageContent_PageContentPartnerInformation
  }
}

fragment DegreeHomePageContent_PremiumCertificatePageContent on PremiumCertificatePageContent {
  certificateName
  partnerInformation {
    ...DegreeHomePageContent_PageContentPartnerInformation
  }
}

fragment DegreeHomePageContent_PageContentPartnerInformation on PartnerInformation {
  bannerImage {
    url
  }
  partnerLogo {
    url
  }
  partnerName
  primaryColor
  secondaryColor
}
`;
